import {
  Membership_Type,
  MembershipFragment,
  Retailer_Network_User_Role,
  RetailerNetworkUserForMemberFragment,
} from '@occc/graphql';
import config from '@occc/config';
import {
  useGetRetailerNetworkLocationsForMember,
  useGetRetailerNetworkLocationGroupsForMember,
  useGetRetailerNetworksForMember,
  useGetRetailerNetworkUsersForMemberQuery,
} from '@occc-app/dataAccessLayer/membership/queries';

export const useMembershipEmployeeData = (member?: MembershipFragment) => {
  const isMemberRcUser = member?.membershipType === Membership_Type.RcUser;
  const isRetailerConnectEnabled = config.retailerConnect.enabled;
  const memberUuid = member?.id || '';
  const skip = !isRetailerConnectEnabled || !isMemberRcUser || !memberUuid;

  const retailerNetworkUsersForMember = useGetRetailerNetworkUsersForMemberQuery({
    filter: {
      membershipUuidEquals: memberUuid,
    },
    skip,
  });
  const isRetailerNetworkAdminOrUser = retailerNetworkUsersForMember.data
    ? retailerNetworkUsersForMember.data.some(
        (item: RetailerNetworkUserForMemberFragment) =>
          item.role === Retailer_Network_User_Role.RetailerNetworkAdmin ||
          item.role === Retailer_Network_User_Role.RetailerNetworkUser,
      )
    : false;

  const employeeLocations = useGetRetailerNetworkLocationsForMember({
    memberUuid,
    skip,
  });
  const isEmployeeLocationsTabVisible = employeeLocations.data?.length > 0;

  const employeeLocationGroups = useGetRetailerNetworkLocationGroupsForMember({
    memberUuid,
    skip,
  });
  const isEmployeeLocationGroupsTabVisible = employeeLocationGroups.data?.length > 0;

  const employeeRetailerNetworks = useGetRetailerNetworksForMember({
    memberUuid,
    skip,
  });
  const isEmployeeRetailerNetworksTabVisible =
    isRetailerNetworkAdminOrUser && employeeRetailerNetworks.data?.length > 0;

  const isEmployeeDetailsTabVisible =
    isMemberRcUser &&
    (isEmployeeLocationsTabVisible ||
      isEmployeeLocationGroupsTabVisible ||
      isEmployeeRetailerNetworksTabVisible);

  const loading =
    retailerNetworkUsersForMember.loading ||
    employeeLocations.loading ||
    employeeLocationGroups.loading ||
    employeeRetailerNetworks.loading;

  return {
    employeeLocations,
    isEmployeeLocationsTabVisible,
    employeeLocationGroups,
    isEmployeeLocationGroupsTabVisible,
    employeeRetailerNetworks,
    isEmployeeRetailerNetworksTabVisible,
    isEmployeeDetailsTabVisible,
    loading,
  };
};
